import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import estudiotv from "../assets/images/Projetos/Estúdios/estudio-televisão.jpg";
import radio from "../assets/images/Projetos/Rádios/radio.jpg";
import ibirapuera from "../assets/images/Projetos/Shooping Ibirapuera/ibirapuera.jpg";
import aeroporto from "../assets/images/Projetos/Aeroporto/aeroporto.jpg";
import bacen from "../assets/images/Projetos/Banco Central do Brasil/banco.jpg";
import antena from "../assets/images/Projetos/Provedores de Internet/antena.jpg";
import mineracao from "../assets/images/Projetos/Mineração/mineracao.jpg";
import usina from "../assets/images/Projetos/Usinas de Açúcar e Álcool/usina1.jpg";
import petroleo from "../assets/images/Projetos/Plataformas de Petróleo/Petroleo.jpg";

import allianz from "../assets/images/Projetos/Estádio Allianz Parque/allianz.jpg";
import velodromo from "../assets/images/Projetos/Velódromo Rio de Janeiro/velodromo.jpg";
import transolimpica from "../assets/images/Projetos/Transolímpica/transolimpica-img3.jpg";
import maracana from "../assets/images/Projetos/Novo Maracanã/novo-maracanã.jpg";

const projects = [
  { img: estudiotv, title: "Estúdio de Televisão", description: "Atuamos com estúdio renomados, como o estúdio do Masterchef da Band e Jornal Nacional da Rede Globo...", link: "/projects-estudio" },
  { img: radio, title: "Rádios", description: "Atendemos as principais Rádios do Estado de São Paulo, como Mix fm, Jovem Pan...", link: "/projects-radios" },
  { img: ibirapuera, title: "Shopping Ibirapuera", description: "O Shopping Ibirapuera é um dos principais shoppings da Grande São Paulo...", link: "/projects-ibirapuera" },
  { img: aeroporto, title: "Aeroporto RIOgaleão", description: "Um dos principais aeroportos do país, com prioridade alta em todos os serviços...", link: "/projects-aeroporto" },
  { img: bacen, title: "Banco Central do Brasil", description: "Para projetos ligados BACEN – Banco Central do Brasil...", link: "/projects-bancocentral" },
  { img: antena, title: "Provedores de Internet", description: "Em trabalhos diretamente ligados a diversos Provedores de Internet...", link: "/projects-provedores" },
  { img: mineracao, title: "Mineração", description: "Atendemos os principais nomes do setor de Mineração, como a Vale...", link: "/projects-mineracao" },
  { img: usina, title: "Usinas de Açúcar e Álcool", description: "Temos participações diretas em projetos para Usinas de Açúcar e Álcool...", link: "/projects-usinas" },
  { img: petroleo, title: "Plataformas de Petróleo", description: "Para diversas Plataformas de Petróleo fornecemos a seguinte solução...", link: "/projects-plataformas" },
  { img: allianz, title: "Estádio Allianz Parque", description: "Para o projeto do Estádio do Allianz Parque participamos diretamente...", link: "/projects-allianz" },
  { img: velodromo, title: "Velódromo Rio de Janeiro", description: "Fornecimento de cabos de incêndio para o velódromo do Rio de Janeiro", link: "/projects-velodromo" },
  { img: transolimpica, title: "Transolímpica", description: "Cobertura indoor na Transolímpica...", link: "/projects-transolimpica" },
  { img: maracana, title: "Novo Maracanã", description: "Fornecimento de cabeamento para controle de acesso e CFTV no estádio novo Maracanã.", link: "/projects-maracana" },
];

const Projects = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleItems = 3;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % projects.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const getVisibleProjects = () => {
    const items = [];
    for (let i = 0; i < visibleItems; i++) {
      items.push(projects[(currentIndex + i) % projects.length]);
    }
    return items;
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + projects.length) % projects.length);
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % projects.length);
  };

  return (
    <>
      <br />
      <h2 className="about-title">Nossos Projetos</h2>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <button
          onClick={goToPrevious}
          style={{
            position: "absolute",
            left: "20px",
            top: "50%",
            transform: "translateY(-50%)",
            background: "rgba(0, 0, 0, 0.5)",
            color: "#fff",
            border: "none",
            padding: "10px",
            cursor: "pointer",
            zIndex: 1,
          }}
        >
          &#8592;
        </button>

        <div
          style={{
            display: "flex",
            gap: "40px",
            transition: "transform 0.5s ease-in-out",
            padding: "20px 0",
            margin: "20px",
          }}
        >
          {getVisibleProjects().map((item, ind) => (
            <Link
              to={item.link}
              key={ind}
              style={{
                position: "relative",
                width: "350px",
                height: "480px",
                borderRadius: "15px",
                overflow: "hidden",
                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
                background: `url(${item.img}) center/cover no-repeat`,
                color: "#fff",
                textDecoration: "none",
                display: "block",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  bottom: "0",
                  width: "100%",
                  padding: "20px",
                  background: "rgba(0, 0, 0, 0.7)",
                  textAlign: "center",
                  height: "220px",
                  pointerEvents: "none", // Permite que o clique vá para o Link
                }}
              >
                <h3
                  style={{
                    fontSize: "22px",
                    marginBottom: "10px",
                    pointerEvents: "auto",
                  }}
                >
                  {item.title}
                </h3>
                <p
                  style={{
                    fontSize: "14px",
                    lineHeight: "1.5",
                    whiteSpace: "pre-line",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    pointerEvents: "auto",
                  }}
                >
                  {item.description}
                </p>
                <span
          style={{
            color: "#fff",
            fontSize: "16px",
            textDecoration: "underline",
            marginTop: "10px",
            display: "block",
            pointerEvents: "none", // Desativa clique só nesse elemento (já que o card inteiro é clicável)
          }}
        >
          Saiba Mais
        </span>
              </div>
            </Link>
          ))}
        </div>

        <button
          onClick={goToNext}
          style={{
            position: "absolute",
            right: "20px",
            top: "50%",
            transform: "translateY(-50%)",
            background: "rgba(0, 0, 0, 0.5)",
            color: "#fff",
            border: "none",
            padding: "10px",
            cursor: "pointer",
            zIndex: 1,
          }}
        >
          &#8594;
        </button>
      </div>
    </>
  );
};

export default Projects;
